import { CheckboxCell } from 'components/common-form/builder/form/node/field/Grid/cells/CheckboxCell';
import { useOnKeyDownWithCanEdit } from 'components/common-form/builder/form/node/field/Grid/cells/hooks';
import type { CellMetadata, FieldMetadata } from 'models/forms/fields';
import { MouseEvent, useCallback } from 'react';

import type { Navigation } from '../GridField.model';
import { CustomizableInput } from './CustomizableInput';

interface Props {
  metadata: FieldMetadata;
  onValueChanged: (row: number, cellId: string, value: unknown) => void;
  rowIndex: number;
  cellId: string;
  e2e: string;
  isSelected: boolean;
  value: unknown;
  customizedData?: CellMetadata;
  onCellSelected: (cellId: string) => void;
  onEditionStarted: (lostInputKey?: KeyboardEventInit) => void;
  onNavigated: (navigation: Navigation) => void;
}

export function BooleanGridCell({
  cellId,
  e2e,
  isSelected,
  metadata,
  value = null,
  rowIndex,
  customizedData,
  onCellSelected,
  onValueChanged,
  onNavigated,
}: Props) {
  const { isReadOnly, id: columnId } = metadata;
  const isCustomized = customizedData?.isCustomized ?? false;
  const onClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      onCellSelected(cellId);
      e.preventDefault();
    },
    [cellId, onCellSelected],
  );
  const onKeyDownWithCanEdit = useOnKeyDownWithCanEdit(onNavigated);
  const onKeyDownEditable = onKeyDownWithCanEdit(!isReadOnly);
  const onChange = useCallback(
    (newValue: unknown = null) => {
      if (newValue !== value) {
        onValueChanged(rowIndex, columnId, newValue);
      }
    },
    [value, onValueChanged, rowIndex, columnId],
  );
  return (
    <CustomizableInput isCustomized={isCustomized}>
      <CheckboxCell
        id={cellId}
        e2e={e2e}
        isSelected={isSelected}
        isReadOnly={isReadOnly}
        isCustomized={isCustomized}
        checked={value as boolean}
        onKeyDown={onKeyDownEditable}
        onClick={onClick}
        onChanged={onChange}
        className="position-absolute top-0 w-100 h-100 p-0"
      />
    </CustomizableInput>
  );
}
